import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { ToastType } from '@components/Toast';
import {
  ApCallingQueueType,
  RemitToQueueType,
} from '@typeDefinitions/apCallingQueueTypes';
import { createError } from '@utils/errorUtils';
import { handleToast } from '@utils/utils';

export const fetchApCallingQueueApi = async (
  payload: Record<string, unknown>,
) => {
  try {
    const response: V4ApiResponse<ApCallingQueueType[]> = await apiClient.post(
      'Queue/apcallingqueue',
      payload,
    );
    if (response.isSuccess) {
      return response.value;
    }
  } catch (e: unknown) {
    const error = createError(e, 'Failed to fetch Ap Calling Queue data');
    handleToast(ToastType.Error, error.message);
  }
};

export const fetchRemitToQueueApi = async (
  payload: Record<string, unknown>,
) => {
  try {
    const response: V4ApiResponse<RemitToQueueType[]> = await apiClient.post(
      '/Queue/remitto',
      payload,
    );
    if (response.isSuccess) {
      return response.value;
    }
  } catch (e: unknown) {
    const error = createError(e, 'Failed to fetch Remit Queue data');
    handleToast(ToastType.Error, error.message);
  }
};

export const editRemitEmailApi = async (id: number, email: string) => {
  try {
    const url = `carrier/updateremitto/${id}?email=${email}`;
    const response: V4ApiResponse<unknown> = await apiClient.post(url);
    if (response.isSuccess) {
      return response.isSuccess;
    }
    handleToast(ToastType.Error, response.errors[0].message);
    return false;
  } catch (e) {
    const error = createError(e, 'Remittance email not saved');
    handleToast(ToastType.Error, error.message);
  }
};

export const exportCallingQueueApi = async (
  payload: Record<string, unknown>,
) => {
  try {
    const response: V4ApiResponse<{ data: string; fileName: string }> =
      await apiClient.post('Queue/exportapcallingqueue', payload, {
        timeout: 60000,
      });
    return response;
  } catch (e) {
    const error = createError(e, 'Failed to export Calling queue CSV');
    handleToast(ToastType.Error, error.message);
  }
};

export const exportRemitToQueueApi = async (
  payload: Record<string, unknown>,
) => {
  try {
    const response: V4ApiResponse<{ data: string; fileName: string }> =
      await apiClient.post('Queue/exportremitto', payload, {
        timeout: 60000,
      });
    return response;
  } catch (e) {
    const error = createError(e, 'Failed to export Remit to queue CSV');
    handleToast(ToastType.Error, error.message);
  }
};
